const DEFAULT_SIGNUP_LOCATION = '/candidates/signup';
export { DEFAULT_SIGNUP_LOCATION };
